import type { GroupStyleI, SimpleStyleT } from "tweenly"

/** The label a style's field shows inside it: its name and unit, e.g. "top (px)". */
export const getStyleFieldLabel = (style: SimpleStyleT | GroupStyleI): string =>
    (style.input.label ?? style.property) + (style.unit ? ` (${style.unit})` : "")

export const isFlexDisplay = (display: string): boolean =>
    display === "flex" || display === "inline-flex"
export const isInlineDisplay = (display: string): boolean =>
    display === "inline-block" || display === "inline-flex"
